export default __webpack_public_path__ + "static/media/greyCloseMenu.1a1ae56f.svg";